import { tagAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

// eslint-disable-next-line @typescript-eslint/unbound-method
const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const baseStyleContainer = defineStyle({
    backgroundColor: 'slt-pepper.50',
    borderRadius: '4px',
    minWidth: 'unset',
    paddingInlineStart: 1,
    paddingInlineEnd: 1,
    minHeight: '26px',
});

const baseStyleLabel = defineStyle({
    textStyle: 'body-small',
    color: 'slt-pepper.1000',
    fontWeight: '400',
    overflow: 'visible',
    whiteSpace: 'nowrap',
    minWidth: 'unset',
});

const baseStyleCloseButton = defineStyle({
    width: 'unset',
    height: 'unset',
    marginInlineStart: '4px',
    marginInlineEnd: 'unset',
    padding: 1,
});

const baseStyle = definePartsStyle({
    container: baseStyleContainer,
    label: baseStyleLabel,
    closeButton: baseStyleCloseButton,
});

const variants = {
    base: baseStyle,
};

export const Tag = defineMultiStyleConfig({
    variants,
    baseStyle,
});
